import axios from '@/libs/axios';

const CustomizationService = {
  /**
   * Retorna a customização visual do tenant atual.
   */
  async get() {
    const response = await axios.get('/settings/customization');
    return response.data;
  },

  /**
   * Atualiza cor primária e/ou logo_url do tenant.
   * @param {{ cor_primaria?: string, logo_url?: string }} data
   */
  async update(data) {
    const response = await axios.put('/settings/customization', data);
    return response.data;
  },

  /**
   * Faz upload de uma imagem de logo.
   * @param {File} file
   * @param {function} onProgress
   */
  async uploadLogo(file, onProgress) {
    const formData = new FormData();
    formData.append('logo', file);

    const response = await axios.post('/settings/customization/logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (evt) => {
        if (onProgress && evt.total) {
          onProgress(Math.round((evt.loaded * 100) / evt.total));
        }
      },
    });
    return response.data;
  },
};

export default CustomizationService;
